import {
  cellStyle,
  InvoiceTypeCode,
  Metadata,
  MultiSelectInput,
  SubTypeLabels,
  widthPresets,
} from '@dx-ui/dx-common';
import { TextInput } from 'react-admin';
import { DocumentSubTypeField, ReceiverIdField } from './CommonFields';

export const createSpecificColumnsInvoice = () => [
  {
    id: Metadata.documentSubTypeCode,
    label: 'dxMessages.headers.documentSubTypeCode',
    sortable: false,
    hiddenByDefault: true,
    width: widthPresets.large,
    cellStyle: cellStyle,
    renderCell: (props) => <DocumentSubTypeField {...props} />,
  },
  {
    id: Metadata.receiverId,
    label: 'dxMessages.headers.receiverId',
    sortable: false,
    hiddenByDefault: true,
    width: widthPresets.large,
    cellStyle: cellStyle,
    renderCell: (props) => <ReceiverIdField {...props} />,
  },
];

export const createSpecificInvoiceFilters = () => [
  {
    id: Metadata.documentSubTypeCode,
    filter: (props) => (
      <MultiSelectInput
        label='dxMessages.headers.documentSubTypeCode'
        source={Metadata.documentSubTypeCode}
        width={widthPresets.large}
        sortLabels={true}
        {...props}
        options={[
          {
            id: InvoiceTypeCode.COMMERCIAL,
            label: SubTypeLabels[InvoiceTypeCode.COMMERCIAL],
          },
          {
            id: InvoiceTypeCode.CANCELLATION,
            label: SubTypeLabels[InvoiceTypeCode.CANCELLATION],
          },
          {
            id: InvoiceTypeCode.CORRECTION,
            label: SubTypeLabels[InvoiceTypeCode.CORRECTION],
          },
          {
            id: InvoiceTypeCode.SELF_BILLING,
            label: SubTypeLabels[InvoiceTypeCode.SELF_BILLING],
          },
          {
            id: InvoiceTypeCode.ACCOUNTING,
            label: SubTypeLabels[InvoiceTypeCode.ACCOUNTING],
          },
        ]}
      />
    ),
  },
  {
    id: Metadata.receiverId,
    filter: (props) => (
      <TextInput
        source={Metadata.receiverId}
        label='dxMessages.filter.receiver.id'
        resettable
        {...props}
      />
    ),
  },
];
